// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3kN0R","label":"Completed_label__2C58g"};